//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import InventoryModel from '@/models/Warehouse/WhInventory'
import ProductModel from '@/models/Warehouse/WhProduct'
import fields from './fields'

//
export default {
    name: 'inventory-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', {
            user: 'user',
        }),

        /**
         *
         */
        canEdit() {
            return (
                this.formData.wh_warehouse_g_branch_office_id ===
                this.user.hr_employee.g_branch_office_id
            )
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                    g_branch_office_id_selected: this.branchOfficeId,
                    triggerWarehouse: this.triggerWarehouse,
                }),
                loading: this.formBusy,
                switchEdit: this.canEdit,
            }
        },
    },
    data() {
        return {
            branchOfficeId: 1,
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', ['setTitleTopBar']),

        //
        ...mapActions('SnackbarModalModule', [
            'setSnackbar',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         *
         */
        fetch() {
            this.formBusy = true
            return InventoryModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'inventory-list' })
        },

        /**
         *
         */
        reset() {
            this.$refs.form
                .setWait(true)
                .then(this.fetch)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        setFormData(model) {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formBusy = false
            this.formData = model.reset()
        },

        /**
         *
         */
        error(error) {
            this.setSnackbar({
                type: 'error',
                title: 'Error.',
                message: Translator(InventoryModel, error.response.data),
                timeout: 3000,
            })
        },

        /**
         *
         */
        success() {
            this.setSuccessSnackbar('Inventario actualizado.').then(
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },

        /**
         *
         */
        async triggerWarehouse(ctx) {
            //
            this.branchOfficeId =
                ctx.getInput('wh_warehouse_id').getSelected()
                    .g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
            this.$refs.form.setWait(true)

            //
            this.formData.wh_selected_products = await Promise.all(
                this.formData.wh_selected_products.map(async e => {
                    //
                    let product = await ProductModel.modeler().find(
                        e.wh_product_id
                    )

                    //
                    e.g_branch_office_id = this.branchOfficeId
                    product.g_branch_office_id = this.branchOfficeId

                    //
                    e['expected_amount'] =
                        product.stock_total || e.expected_amount || 0

                    //
                    return e
                })
            )

            this.$refs.form.setWait(false)
        },

        /**
         *
         */
        update(model) {
            model
                .toUpdate()
                .save()
                .then(this.success)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos de inventario')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_INVENTORY')) ctx.$router.push('/')
        })
    },
}
